var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        [
          _c("div", { staticClass: "tip" }, [
            _c("p", [
              _vm._v(
                "1. 上传包含两个Sheet的Excel：第1个为用户信息，第2个为优惠券信息。"
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("2. 上传成功后会获得文件路径，点击“开始导入”提交。"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              staticClass: "form",
              attrs: { model: _vm.form, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Excel文件" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-block",
                      attrs: {
                        action: _vm.uploadUrl,
                        headers: _vm.headers,
                        data: _vm.uploadData,
                        name: "file",
                        "show-file-list": false,
                        "on-success": _vm.handleSuccess,
                        "on-error": _vm.handleError,
                        "before-upload": _vm.beforeUpload,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "primary", loading: _vm.uploading } },
                        [_vm._v("选择Excel")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.url
                    ? _c("div", { staticClass: "file-path" }, [
                        _vm._v("已上传：" + _vm._s(_vm.form.url)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "客户ID" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户ID" },
                    model: {
                      value: _vm.form.customerId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "customerId", $$v)
                      },
                      expression: "form.customerId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "应用ID" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入小程序/应用ID" },
                    model: {
                      value: _vm.form.appId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "appId", $$v)
                      },
                      expression: "form.appId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "金豆ID", prop: "goldCardId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "可选，金豆ID（无门槛券折算）" },
                    model: {
                      value: _vm.form.goldCardId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "goldCardId", $$v)
                      },
                      expression: "form.goldCardId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "普通福卡ID", prop: "normalCardId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "可选，普通福卡ID（通用卡余额）" },
                    model: {
                      value: _vm.form.normalCardId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "normalCardId", $$v)
                      },
                      expression: "form.normalCardId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "荣汇佳专用卡ID", prop: "specialCardId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "可选，荣汇佳专用卡ID" },
                    model: {
                      value: _vm.form.specialCardId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "specialCardId", $$v)
                      },
                      expression: "form.specialCardId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Token类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择token类型" },
                      model: {
                        value: _vm.form.tokenType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "tokenType", $$v)
                        },
                        expression: "form.tokenType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { value: 1, label: "公众号" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { value: 2, label: "小程序" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("开始导入")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }